<script>
import Loading from "@/components/layout/Loading.vue";
import { mapActions } from "vuex";
import Likes from "@/components/likes.vue";
import { toDate, toTime } from "@/utils/time.js";
import TextTruncator from "@/components/structures/TextTruncator.vue";
import Tooltip from "@/components/Tooltip.vue";
export default {
  props: {
    data: {},
    loading: {
      type: Boolean,
      required: true,
    },
  },
  components: {
    Loading,
    Likes,
    TextTruncator,
    Tooltip,
  },
  data() {
    return {
      likesSelected: [],
      action: false,
      currentImageIndex: 0,
      imageInterval: null,
      timeInterval: 10000,
    };
  },
  mounted() {
    if (this.data && this.data.imagenes && this.data.imagenes.length > 1) {
      this.galerryInterval();
    }
  },
  beforeDestroy() {
    if (this.imageInterval) {
      clearInterval(this.imageInterval);
    }
  },
  watch: {
    data(newValue, oldValue) {
      if (newValue.imagenes !== oldValue.imagenes) {
        this.currentImageIndex = 0;
        if (this.imageInterval) {
          clearInterval(this.imageInterval);
        }
        if (newValue.imagenes && newValue.imagenes.length > 1) {
          this.imageInterval = setInterval(() => {
            this.currentImageIndex =
              (this.currentImageIndex + 1) % newValue.imagenes.length;
          }, this.timeInterval);
        }
      }
    },
  },
  computed: {
    galeryLikesPhotos() {
      return this.data.imagenes
        .map(({ likes }) => likes.length)
        .reduce((acc, cur) => acc + cur, 0);
    },
  },
  methods: {
    ...mapActions("home", ["addLikeLastGallery", "delLikeLastGallery"]),
    galerryInterval() {
      if (this.imageInterval) {
        clearInterval(this.imageInterval);
      }
      this.imageInterval = setInterval(() => {
        if (this.likesSelected.length === 0 && this.action === false)
          this.currentImageIndex =
            (this.currentImageIndex + 1) % this.data.imagenes.length;
      }, this.timeInterval);
    },
    getYearAndMonth(date) {
      const newDate = new Date(date);
      newDate.setDate(newDate.getDate() + 1);
      return {
        year: newDate.toLocaleString("es-CL", { year: "numeric" }),
        month: newDate.toLocaleString("es-CL", { month: "numeric" }),
      };
    },

    getLikesCount(galeria) {
      return galeria.imagenes.reduce((acc, cur) => acc + cur.likes.length, 0);
    },

    textLike(gal) {
      const { likes, confirm_like } = gal;
      if (likes.length == 0) return "";
      if (likes.length == 1 && confirm_like != null) return "Te gusta";
      return "Le gusta a";
    },
    async toggleLikeGal(gal) {
      this.action = true;
      const data_ = {
        id_empresa: this.$ls.get("user").id_empresa_fk,
        id_usuario: this.$ls.get("user").id_usuario,
        id_objeto: `${this.data.id_galeria}`,
        id_subobjeto: `${gal.id_imagen}`,
      };

      let res = null;

      if (this.data.imagenes[this.currentImageIndex].confirm_like == null) {
        res = await this.addLikeLastGallery(data_);
      } else {
        res = await this.delLikeLastGallery(data_);
      }
      if (!res) {
        this.toastGenericError();
      }
      setTimeout(() => {
        this.action = false;
        this.galerryInterval();
      }, 300);
    },
    toDate(date) {
      return toDate(date);
    },
    toTime(date) {
      return toTime(date);
    },
    likesSelectedOpen(likes) {
      this.likesSelected = likes;
    },
    likesSelectedClose() {
      this.likesSelected = [];
      this.galerryInterval();
    },
  },
};
</script>

<template>
  <section class="widget">
    <Loading v-if="loading" pixeles="100px" class="mb-3" />
    <div v-if="!loading" class="card card-custom border-0 mb-3">
      <div
        class="d-flex justify-content-between align-items-center p-3 pb-0 color-main"
      >
        <p class="d-flex align-items-center font-title font-700 mb-0">
          <img
            height="40"
            src="@/assets/img/intranet/home/img-card-galeria.png"
          />
          <span>Última galería</span>
        </p>
        <router-link
          class="font-title font-700 color-main"
          :to="`/galeria/${data.id_galeria}`"
        >
          Ver más
        </router-link>
      </div>
      <div class="card-body h-auto">
        <figure class="card-custom-thumb">
          <router-link
            class="card-custom-thumb-link"
            :to="`/galeria/${data.id_galeria}`"
          >
            <transition name="fade" mode="out-in">
              <img
                :key="'img-' + currentImageIndex"
                :src="data.imagenes[currentImageIndex].url_imagen_original"
                class="card-custom-thumb-img border"
              />
            </transition>
          </router-link>
        </figure>
        <div class="d-flex align-items-right">
          <small class="m-0 ms-auto text-secondary text-right">
            {{ toDate(data.fecha_galeria) }} {{ toTime(data.fecha_galeria) }}
          </small>
        </div>
        <div class="card-custom-post">
          <TextTruncator
            class="font-700 text-secondary mb-0"
            :max="100"
            tag="h5"
          >
            {{ data.titulo_galeria }}
          </TextTruncator>
        </div>
      </div>
      <div
        class="card-custom-footer d-flex p-3 pt-0 justify-content-end align-items-center"
      >
        <Tooltip class="me-auto">
          <template slot="text">
            Total de likes <br />
            entre todas las fotos
          </template>
          <a href="javascript:" class="card-custom-footer-like">
            <font-awesome-icon
              icon="fa-solid fa-hand-holding-heart"
              class="font"
              :class="{ 'color-red': galeryLikesPhotos > 0 }"
            ></font-awesome-icon>
            {{ galeryLikesPhotos }}
          </a>
        </Tooltip>

        <a
          href="javascript:"
          @click="
            textLike(data.imagenes[currentImageIndex]) !== 'Te gusta' &&
              likesSelectedOpen(data.imagenes[currentImageIndex].likes)
          "
          class="me-2"
        >
          {{ textLike(data.imagenes[currentImageIndex]) }}
        </a>
        <a
          class="card-custom-footer-like color-main"
          style="cursor: default"
          :class="{
            'color-red': data.imagenes[currentImageIndex].confirm_like !== null,
          }"
          @click="toggleLikeGal(data.imagenes[currentImageIndex])"
        >
          <font-awesome-icon icon="fa-solid fa-heart"></font-awesome-icon>
        </a>
        <span class="card-custom-footer-like-count ms-2">
          {{ data.imagenes[currentImageIndex].likes.length }}
        </span>
      </div>
    </div>
    <Likes
      v-show="likesSelected.length > 0"
      :likes="likesSelected"
      @close="likesSelectedClose"
    ></Likes>
  </section>
</template>
